'use client';

import React, { forwardRef, type ReactNode } from 'react';
import { PolymorphicComponentProps } from 'styled-components';

import { ItemBase, Title, Badge } from './Item.styled';

export type ItemBaseProps = {
  title: string;
  icon: ReactNode;
  trackid?: string;
  active?: boolean;
  hideTextOnMobile?: boolean;
  badge?: ReactNode;
};

export type ItemProps = PolymorphicComponentProps<
  'web',
  ItemBaseProps,
  'a',
  'button'
>;

function Item(
  {
    title,
    icon,
    active = false,
    hideTextOnMobile = true,
    badge,
    ...props
  }: ItemProps,
  ref: ItemProps['ref']
) {
  return (
    <ItemBase ref={ref} type="button" $active={active} {...props}>
      {icon}
      <Title $hideOnMobile={hideTextOnMobile}>{title}</Title>
      {!!badge && <Badge>{badge}</Badge>}
    </ItemBase>
  );
}

export default forwardRef(Item);
